import { render } from "./HelpCatalogConfig.vue?vue&type=template&id=30188730&scoped=true"
import script from "./HelpCatalogConfig.vue?vue&type=script&lang=js"
export * from "./HelpCatalogConfig.vue?vue&type=script&lang=js"

import "./HelpCatalogConfig.vue?vue&type=style&index=0&id=30188730&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30188730"]])

export default __exports__